function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReconTransact({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#EEF3FC",
    style: {
      fill: "#EEF3FC",
      fill: "color(display-p3 0.9333 0.9529 0.9882)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6069 22.5955C12.2902 21.8988 13.3319 21.9543 13.9319 22.7143L14.7735 23.783C15.4485 24.6301 16.5402 24.6301 17.2152 23.783L18.0569 22.7143C18.6569 21.9543 19.6985 21.8988 20.3819 22.5955C21.8652 24.0997 23.0735 23.6009 23.0735 21.4951V12.573C23.0735 9.38259 22.2902 8.58301 19.1402 8.58301H12.8402C9.69019 8.58301 8.90686 9.38259 8.90686 12.573V21.4872C8.91519 23.6009 10.1319 24.0918 11.6069 22.5955Z",
    stroke: "#2A5392",
    style: {
      stroke: "#2A5392",
      stroke: "color(display-p3 0.1647 0.3255 0.5725)",
      strokeOpacity: 1
    },
    strokeWidth: 1.57895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7084 14.916H18.2917",
    stroke: "#2A5392",
    style: {
      stroke: "#2A5392",
      stroke: "color(display-p3 0.1647 0.3255 0.5725)",
      strokeOpacity: 1
    },
    strokeWidth: 1.57895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReconTransact);
export default __webpack_public_path__ + "static/media/recon-transact.529c10911c39af3e402fa570a1dc1567.svg";
export { ForwardRef as ReactComponent };